export default __webpack_public_path__ + "static/thumb-landscape-a99d7604162bef6bd813b3fa38287c43.jpg";